import * as yup from 'yup'
import moment from 'moment'
import { validation } from 'components/form-control'

export const schemas = [
  validation({
    last_name: yup
      .string()
      .required()
      .min(2)
      .max(30)
      .matches(/^[а-яёА-ЯЁa-zA-Z\s-]*$/i, 'Только буквенные символы'),
    first_name: yup
      .string()
      .required()
      .min(2)
      .max(30)
      .matches(/^[а-яёА-ЯЁa-zA-Z\s-]*$/i, 'Только буквенные символы'),
    middle_name: yup.string().matches(/^[а-яёА-ЯЁa-zA-Z\s-]{2,30}$/i, {
      message: 'Только буквенные символы',
      excludeEmptyString: true,
    }),
  }),

  validation({
    phone: yup
      .string()
      .required()
      .matches(/^\d{10}$/i, { message: 'Указан некорректный номер телефона', excludeEmptyString: true }),
    email: yup.string().required().email(),
    address: yup
      .object()
      .typeError('Выберите регион и населенный пункт')
      .required('Выберите регион и населенный пункт')
      .test('city-or-np', 'Выберите регион и населенный пункт', (a) => a?.city || a?.np),
  }),

  validation({
    breed_species_id: yup
      .number()
      .typeError('Выберите питомца из списка')
      .required('Выберите питомца из списка')
      .positive()
      .integer(),
    breed_id: yup
      .object()
      .typeError('Выберите породу из списка')
      .required('Выберите породу из списка')
      .test('number', 'Выберите породу из списка', (i) => i?.id),
    pet_name: yup
      .string()
      .required()
      .min(2)
      .max(30)
      .matches(/^[а-яёА-ЯЁa-zA-Z\s-]*$/i, 'Только буквенные символы'),
    pet_birthday_at: yup
      .string()
      .required()
      .test({ test: (val, _) => val?.toLowerCase() !== 'invalid date', message: 'Введена некорректная дата' })
      .test({
        test: (val, _) => moment(val).isAfter('1980-01-01') && moment(val).isBefore(new Date()),
        message: 'Дата вне допустимого интервала',
      }),
  }),

  validation({
    nursery_recorder_id: yup
      .number()
      .typeError('Поле обязательно для заполнения')
      .required('Поле обязательно для заполнения')
      .positive()
      .integer(),
    register_focus_id: yup
      .number()
      .typeError('Поле обязательно для заполнения')
      .required('Поле обязательно для заполнения')
      .positive()
      .integer(),
    breeder_phone: yup
      .string()
      .when('nursery_recorder_id', {
        is: 1, // или (value) => value === 1
        then: (schema) => schema
          .matches(/^\d{10}$/, {
            message: 'Указан некорректный номер телефона'
          })
          .required('Телефон заводчика обязателен для заполнения'),
        otherwise: (schema) => schema
          .notRequired()
          .nullable()
      }),

    rules: yup.boolean().oneOf([true], 'Необходимо согласиться с условиями').default(false),
    pdn: yup.boolean().oneOf([true], 'Необходимо согласие').default(false),
    subscribe_sms: yup.boolean().default(false),
    subscribe_email: yup.boolean().default(false),
  }),
]
